import { Button } from 'procyon-ui'
import React from 'react'
import { cn } from 'Utils/Helpers'
/**
 *
 * @param {{
 * buttons: { label: string, onClick?:() => void, key: string }[]
 * activeButtonKey?: string
 * onActiveButtonKeyChange?: (key: string) => void
 * }} param0
 * @returns
 */
function ButtonGroup({ buttons, activeButtonKey, onActiveButtonKeyChange }) {
  return (
    <div className='flex items-center'>
      {buttons.map((button, index) => {
        const isActive = button.key === activeButtonKey
        return (
          <Button
          className={cn({
            '!rounded-none !border-l-0 !border-r-0': index > 0 && index < buttons.length - 1,
            '': isActive,
            '!rounded-r-none': index === 0,
            '!rounded-l-none': index === buttons.length - 1
          })}
            variant={isActive ? 'primary' : 'gray'}
            key={button.key}
            onClick={() => {
              onActiveButtonKeyChange(button.key)
              button.onClick?.()
            }}
          >
            {button.label}
          </Button>
        )
      })}
    </div>
  )
}

export { ButtonGroup }
